var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-heading__pic[data-v-22fefa13] {\n  background-image: url(" + escape(require("../../../../public/img/common/account_pic.png")) + ");\n  background-size: contain;\n  height: 10vw;\n  width: 10vw;\n  max-width: 50px;\n  max-height: 50px;\n}\n.acount__pic img[data-v-22fefa13] {\n  height: 100%;\n}\n", ""]);

// exports
